import React from 'react';
import { Icon } from '@global-ecom/nitro-uds/elements';

import { useTranslate } from 'hooks/useTranslations';
import { useProductListFilterContext } from 'ui/components/ProductListFilterProvider';

export const ProductListClearAllFilters: React.FC<
  React.ComponentProps<'button'>
> = props => {
  const t = useTranslate();

  const { clearAllFilters, enabledFilters } = useProductListFilterContext();

  return enabledFilters.length === 0 ? null : (
    <button
      data-test-id="clear-all-filters"
      className="focus:outline-none focus:ring-2 ring-puma-gold relative pr-7 pl-2 h-8 capitalize text-puma-black text-xs tracking-wide uppercase font-bold whitespace-nowrap flex-0 flex items-center"
      onClick={clearAllFilters}
      type="button"
      {...props}
    >
      {t('clearAll')}
      <span className="sr-only">{t('filters')}</span>
      <span className="absolute right-2 mt-px top-2/4 -translate-y-1/2">
        <Icon name="close-outline" size="lg" color="muted" />
      </span>
    </button>
  );
};
